import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import { motion } from 'framer-motion';
import useScrollAnimation from '../hooks/useScrollAnimation';
import './Footer.css';

const sectionVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const columnVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.5, ease: 'easeOut' },
  }),
};

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { ref: footerRef, isVisible: footerVisible } = useScrollAnimation({ threshold: 0.1 });

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <motion.div
        ref={footerRef}
        className="footer-container"
        variants={sectionVariants}
        initial="hidden"
        animate={footerVisible ? 'visible' : 'hidden'}
      >
        <div className="footer-content">
          <motion.div className="footer-column" custom={0} variants={columnVariants} initial="hidden" animate={footerVisible ? 'visible' : 'hidden'}>
            <div className="footer-logo-wrapper">
              <img src="/vyznit_logo.png" alt="VYZN Info Tech LLP" className="footer-logo-image" />
            </div>
            <p className="body-small footer-description">
              Building AI-powered technology solutions that help businesses and families operate smarter and more efficiently.
            </p>
            <div className="footer-social">
              <motion.a
                href="https://www.linkedin.com/company/vyznit"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
                whileHover={{ y: -4, scale: 1.1 }}
                transition={{ duration: 0.2 }}
              >
                <Linkedin size={20} />
              </motion.a>
              <motion.a
                href="mailto:info@vyznit.com"
                className="social-link"
                aria-label="Email"
                whileHover={{ y: -4, scale: 1.1 }}
                transition={{ duration: 0.2 }}
              >
                <Mail size={20} />
              </motion.a>
            </div>
          </motion.div>

          <motion.div className="footer-column" custom={1} variants={columnVariants} initial="hidden" animate={footerVisible ? 'visible' : 'hidden'}>
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a onClick={() => scrollToSection('services')}>Services</a></li>
              <li><a onClick={() => scrollToSection('why-choose-us')}>Why Choose Us</a></li>
              <li><a onClick={() => scrollToSection('case-studies')}>Case Studies</a></li>
              <li><a onClick={() => scrollToSection('contact')}>Contact</a></li>
            </ul>
          </motion.div>

          <motion.div className="footer-column" custom={2} variants={columnVariants} initial="hidden" animate={footerVisible ? 'visible' : 'hidden'}>
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><a>Agentic AI</a></li>
              <li><a>LLM & SLM</a></li>
              <li><a>Machine Learning</a></li>
              <li><a>IoT & Edge Computing</a></li>
              <li><a>Cloud Platforms</a></li>
            </ul>
          </motion.div>

          <motion.div className="footer-column" custom={3} variants={columnVariants} initial="hidden" animate={footerVisible ? 'visible' : 'hidden'}>
            <h4 className="footer-title">Contact</h4>
            <ul className="footer-links">
              <li>
                <a>917, Shaligram Arcade, Nr Vakil Saheb Bridge<br />S P Ring Road, Bopal<br />Ahmedabad, Gujarat-380058</a>
              </li>
              <li><a href="mailto:info@vyznit.com">info@vyznit.com</a></li>
              <li><a href="tel:+919998073094">+91 99980 73094</a></li>
            </ul>
          </motion.div>
        </div>

        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          animate={footerVisible ? { opacity: 1 } : {}}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <p className="body-small">
            &copy; {currentYear} VYZN Info Tech LLP. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
        </motion.div>
      </motion.div>
    </footer>
  );
};

export default Footer;